"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _5F7H6NQVcjs = require('../__chunks/5F7H6NQV.cjs');
require('../__chunks/EXYNE2GE.cjs');
require('../__chunks/FAZMJLCO.cjs');
require('../__chunks/XDATOVDX.cjs');
require('../__chunks/JLMLKTUB.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-heading.tsx
var TagName = "h1";
var useMenuHeading = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuHeading2(props) {
    props = _5F7H6NQVcjs.useHovercardHeading.call(void 0, props);
    return props;
  }
);
var MenuHeading = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuHeading2(props) {
  const htmlProps = useMenuHeading(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuHeading = MenuHeading; exports.useMenuHeading = useMenuHeading;
